import {Fragment, useState} from "react";
import {format} from "date-fns";
import {BreadCrumb, CenteredModal, FormInput, TablePaging} from "~/components";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PaymentInformationAPI from '~/api/paymentInformationApi';

const breadCrumbItem = [
    { text: "AI Chatbot Page", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Payment Information", to: "", isActive: true },
]

function PaymentInformation() {
    const [reloadTable, setReloadTable] = useState(false);
    const [paymentInfoDetails, setPaymentInfoDetails] = useState({})
    const [showModal, setShowModal] = useState(false);
    const tablePagingConfig = {
        columns: [
            {
                name: 'ID',
                width: '70px',
                className: 'fw-bold',
                key: 'PaymentInformationId'
            },
            {
                name: 'PAYER',
                width: '150px',
                className: 'fw-bold',
                key: 'Payer',
                template: (row) => {
                    return (
                        <div className=" d-flex align-items-center text-body" data-discover="true">
                            <div className="avatar avatar-m">
                                <img alt="avatar" className="rounded-circle" src={row.AvatarUrl}/>
                            </div>
                            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{row.UserName}</p>
                        </div>
                    )
                }
            },
            {
                name: 'STRIPE SESSION ID',
                width: '200px',
                key: 'StripeSessionId'
            },
            {
                name: 'AMOUNT',
                className: "text-center",
                headerClassName: 'text-center',
                width: '100px',
                key: 'Amount'
            },
            {
                name: 'CURRENCY',
                width: '130px',
                key: 'Currency'
            },
            {
                name: 'DESCRIPTION',
                width: '150px',
                key: 'Description'
            },
            {
                name: 'CUSTOMER EMAIL',
                width: '150px',
                key: 'CustomerEmail'
            },
            {
                name: 'STATUS',
                width: '150px',
                key: 'Status'
            },
            {
                name: 'CREATED AT',
                width: '150px',
                key: 'CreatedAt',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.CreatedAt), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'CARD LAST 4',
                width: '150px',
                key: 'CardLast4'
            },
            {
                name: 'CARD BRAND',
                width: '150px',
                key: 'CardBrand'
            },
            {
                name: 'CARD EXP MONTH',
                width: '150px',
                key: 'CardExpMonth'
            },
            {
                name: 'CARD EXP YEAR',
                width: '150px',
                key: 'CardExpYear'
            },
            {
                name: 'PAYMENT METHOD ID',
                width: '150px',
                key: 'PaymentMethodId'
            },
            {
                name: 'ADDRESS LINE 1',
                width: '150px',
                key: 'AddressLine1'
            },
            {
                name: 'ADDRESS LINE 2',
                width: '150px',
                key: 'AddressLine2'
            },
            {
                name: 'CITY',
                width: '110px',
                key: 'City'
            },
            {
                name: 'STATE',
                width: '110px',
                key: 'State'
            },
            {
                name: 'POSTAL CODE',
                width: '110px',
                key: 'PostalCode'
            },
            {
                name: 'COUNTRY',
                width: '120px',
                key: 'Country'
            },
            {
                name: 'ERROR DESCRIPTION',
                width: '150px',
                key: 'ErrorDescription'
            },
            {
                name: 'CARD HOLDER NAME',
                width: '150px',
                key: 'CardHolderName'
            },
            {
                name: 'ACTION',
                width: '70px',
                key: 'Action',
                headerClassName: "text-center",
                className: 'text-center',
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handlePaymentInfoDetail(row.PaymentInformationId)} icon={faEye} className="text-primary cursor-pointer"/></span>
                    )
                }
            }
        ],
        url: "/payment-information/paged",
        tableKey: "TablePaymentInformation"
    }

    const detailFields = [
        {name: "StripeSessionId", label: "Stripe Session Id"},
        {name: "Amount", label: "Amount"},
        {name: "Currency", label: "Currency"},
        {name: "Description", label: "Description"},
        {name: "CustomerEmail", label: "Customer Email"},
        {name: "Status", label: "Status"},
        {name: "CreatedAt", label: "Created At"},
        {name: "CardLast4", label: "CardLast4"},
        {name: "PricePerMonth", label: "Price Per Month"},
        {name: "CardBrand", label: "Card Brand"},
        {name: "CardExpMonth", label: "Card Exp Month"},
        {name: "CardExpYear", label: "Card Exp Year"},
        {name: "PaymentMethodId", label: "Payment Method Id"},
        {name: "AddressLine1", label: "AddressLine 1"},
        {name: "AddressLine2", label: "AddressLine 2"},
        {name: "City", label: "City"},
        {name: "State", label: "State"},
        {name: "PostalCode", label: "Postal Code"},
        {name: "Country", label: "Country"},
        {name: "ErrorDescription", label: "Error Description"},
        {name: "CardHolderName", label: "Card Holder Name"}
    ]

    const handlePaymentInfoDetail = (paymentInformationId) => {
        PaymentInformationAPI.getById(paymentInformationId)
            .then((res) => {
                setPaymentInfoDetails(res.data);
                setShowModal(true);
            })
            .catch((error) => {
                console.error(error);
            })
    }

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-5">Payment Information</h2>
            <TablePaging tablePagingConfig={tablePagingConfig} reloadTable={reloadTable}/>
            <CenteredModal
                show={showModal}
                onClose={() => setShowModal(false)}
                title="Payment Information Details"
                closeText="Close"
                modalType="modal-lg"
            >
                <div className="row">
                    <div>
                        <div className=" d-flex align-items-center text-body justify-content-center flex-column" data-discover="true">
                            <div className="avatar avatar-xl">
                                <img alt="avatar" className="rounded-circle" src={paymentInfoDetails.AvatarUrl}/>
                            </div>
                            <p className="my-3 text-body-emphasis fw-semibold">{paymentInfoDetails.UserName}</p>
                        </div>
                    </div>
                    {
                        detailFields.map((item, index) => (
                            <div className="col-sm-6 col-12" key={index}>
                                <FormInput showHeaderLabel={true}
                                           name={item.name}
                                           required={false}
                                           disabled={true}
                                           value={paymentInfoDetails[item.name]}
                                           label={`Assign ${item.label}`}
                                           maxLengthText=""
                                />
                            </div>
                        ))
                    }
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default PaymentInformation;